import React from "react";
import { connect } from "react-redux";
import { getGlobalState } from "@/actions/globalState";
import { isValidIP, getParameterByName } from "@/utils/utils";
import Router from '../routes/pc-index';
import { hrefChangeUrl } from "@/utils/utils";

const mapDispatchToProps = { getGlobalState };

const Login = props => {
  const deviceType = getParameterByName("deviceType")
  const isLocal = isValidIP(window.location.hostname);
  const reg = /[a-zA-Z0-9.]*crm[a-zA-Z0-9-]*.weiwenjia.com/;

  // 本地环境显示侧边栏及头部
  if(isLocal){
    //本地登录从环境变量获取token
    window.current_user_token = process.env.LXY_USER_TOKEN
    window.crm_platform_type = process.env.CRM_PLATFORM_TYPE

    props.getGlobalState( () => {
      return Promise.resolve({
        success: true,
        data:{
          showMenu: true,
        }
      })
    })
  }

  //营销素材授权公众号需同域名，融合crm后跳转traffic域名带wechat参数跳转保证同域名授权
  const wechat = getParameterByName("wechat")
  if(wechat){
    // window.location.href = decodeURIComponent(wechat);
    hrefChangeUrl(decodeURIComponent(wechat));
  }

  let PLAT = JSON.parse(sessionStorage.getItem('PLAT')) || null;
  let token = JSON.parse(sessionStorage.getItem('userToken')) || '';
  console.log('PLAT', PLAT?.data)
  console.log('token', token?.data)
  // h5获取url传入token
  if(deviceType === 'h5Side') {
    // 侧边栏
    window.current_user_token = getParameterByName("userToken") || window.AppConf && window.AppConf.user.token;
    // crm_platform_type励销企微版为wxwork,励销独立版为lixiaoyun
    // eslint-disable-next-line no-useless-escape
    if(reg.test(window.location.host)){
      window.crm_platform_type = "lixiaoyun"
    } else {
      window.crm_platform_type = "wxwork"
    }
  } else if (PLAT && PLAT.data) {
    // 在crm-mobile app中 或 移动端 wx app中
    console.log('window.AppConf?.loginType==>', window.AppConf?.loginType)
    window.deviceType = 'crm-mobile'
    window.current_user_token = token?.data || 'a51a2359f95e71c10a62bbeb58b5969d'
    window.crmPLAT = PLAT.data
    // debugType 用于本地调试
    // PLAT用来判断是否是移动端入口，pc端无此值
    // 从侧边栏免登跳转PC,会写入PLAT导致pc端登录crm_platform_type被错误重写,如果存在crm_platform_type则不写入
    if(!window.crm_platform_type){
      if((reg.test(window.location.host) && window.AppConf?.loginType === 'hybrid') || localStorage.getItem('debugType') === 'lixiaoyun'){
        window.crm_platform_type = "lixiaoyun"
      } else {
        window.crm_platform_type = "wxwork"
      }
    }
  }

  return <Router />
};

export default connect(null, mapDispatchToProps)(Login);
